import { Navigate } from 'react-router-dom';

import { useAuthStore } from '@/shared/auth/auth.store';
import { Skeleton } from '@/shared/components/ui/skeleton';

/**
 * Smart redirect para `/`. Aguarda o boot do auth.store (`isLoading`) e
 * decide entre `/home` (autenticado) e `/welcome` (publico). Evita flash
 * de welcome para usuarios com sessao valida.
 */
export function RootRedirect() {
  const isLoading = useAuthStore((s) => s.isLoading);
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  if (isLoading) {
    return (
      <div
        className="flex min-h-screen items-center justify-center bg-canvas px-6"
        data-testid="root-redirect-loading"
        role="status"
        aria-label="Carregando aplicação"
      >
        <Skeleton height={32} className="w-40" />
      </div>
    );
  }

  return <Navigate to={isAuthenticated ? '/home' : '/welcome'} replace />;
}
